import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';

function ScrollToTop() {
  const { pathname } = useLocation();
  const { locale } = useLanguage();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, locale]);

  useEffect(() => {
    if (window.WOW) {
      // Re-initialize WOW on route change. Setting live: true enables
      // MutationObserver, which automatically registers elements loaded from API asynchronously.
      new window.WOW({ live: true }).init();
    }
  }, [pathname, locale]);

  return null;
}

export default ScrollToTop;
